import { useContext } from 'react';
import { ExternalLink, Settings, ShieldCheck, Tags, User, UsersRound } from 'lucide-react';
import { DocFiltersContext } from '../DocFiltersContext';
import { useAuth } from '../../../context/AuthContext';

const SECTIONS = [
    { id: 'categories', label: 'Catégories', icon: Tags },
    { id: 'groups', label: 'Groupes', icon: UsersRound },
];

export default function DocSettingsSidebarBody() {
    const ctx = useContext(DocFiltersContext);
    const { user, isAdmin } = useAuth();
    const activeSection = ctx?.settingsSection ?? 'categories';
    const setSection = ctx?.setSettingsSection;

    const roles = user?.roles ?? [];

    return (
        <div className="flex flex-col h-full">
            <div className="px-4 py-3.5 border-b border-stone-100 flex items-center gap-2">
                <Settings size={14} className="text-stone-400" />
                <span className="text-xs font-semibold text-stone-700 uppercase tracking-wider">Configuration</span>
            </div>

            <nav className="flex-1 overflow-y-auto doc-sidebar-scroll px-2 py-3 space-y-0.5" aria-label="Sections de configuration">
                {SECTIONS.map((section) => {
                    const Icon = section.icon;
                    const isActive = activeSection === section.id;
                    return (
                        <button
                            key={section.id}
                            type="button"
                            onClick={() => setSection?.(section.id)}
                            className={`flex items-center gap-2.5 w-full px-3 py-2 text-sm rounded-lg transition-colors ${
                                isActive
                                    ? 'bg-stone-200/60 text-stone-900 font-medium'
                                    : 'text-stone-500 hover:text-stone-800 hover:bg-stone-100'
                            }`}
                        >
                            <Icon size={14} className={isActive ? 'text-stone-700' : 'text-stone-400'} />
                            <span>{section.label}</span>
                        </button>
                    );
                })}
            </nav>

            {user && (
                <div className="border-t border-stone-200 px-4 py-3 flex-shrink-0 space-y-2.5">
                    <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0">
                            <User size={14} className="text-stone-500" />
                        </div>
                        <div className="min-w-0">
                            <span className="block text-sm font-medium text-stone-800 truncate">
                                {user.name}
                            </span>
                            <div className="flex items-center gap-1 flex-wrap">
                                {isAdmin && (
                                    <span className="inline-flex items-center gap-0.5 text-[10px] font-medium text-iris-700 bg-iris-50 px-1.5 py-px rounded-full">
                                        <ShieldCheck size={9} />
                                        Admin
                                    </span>
                                )}
                                {roles.filter((r) => r !== 'authenticated' && r !== 'administrator').map((role) => (
                                    <span key={role} className="text-[10px] font-medium text-stone-500 bg-stone-100 px-1.5 py-px rounded-full">
                                        {role}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <a
                        href="/docs/profile"
                        className="flex items-center gap-2 px-2.5 py-1.5 text-xs text-stone-500 hover:text-stone-800 hover:bg-stone-100 rounded-lg transition-colors w-full"
                    >
                        <ExternalLink size={12} />
                        <span>Mon profil</span>
                    </a>
                </div>
            )}
        </div>
    );
}
